import { ROLE_RANKING } from "@/users/getHighestRoleLevel/getHighestRoleLevel.constants";
import { User as UserV3 } from "@/types/models/User/v3/User.interface";

const getMostSeniorUserRole = (roles: UserV3["roles"]) => {
  return ROLE_RANKING.find((role) => roles?.includes(role));
};

export default getMostSeniorUserRole;
